import { useEffect } from "react";
import { IUseAddThemeToHtmlElement } from "./types";

export const GetBankColorTheme = (centerId?: string) => {
  if (centerId === "0000") return "theme_norne";
  if (centerId === "3411") return "theme_fanaSparebank";
  if (centerId === "9090") return "theme_eika";
  if (centerId === "3910") return "theme_sparebankenMøre";
  if (centerId === "3890") return "theme_sparebankenSognOgFjordane";
  if (centerId === "9820") return "theme_obosBank";
  if (centerId === "3601" || centerId === "2811") return "theme_sparebankenVest";
  if (centerId === "2220") return "theme_sparebankenØst";
  if (centerId === "4484") return "theme_aasenSparebank";
  if (centerId === "4589" || centerId === "4730" || centerId === "4605") return "theme_sekstiAatteGraderNord";
  if (centerId === "1100") return "theme_asbank";
  if (centerId === "3030") return "theme_flekkefjord";
  if (centerId === "2850") return "theme_lillesand";
  if (centerId === "3785") return "theme_luster";
  if (centerId === "4358") return "theme_nidaros";
  if (centerId === "4285") return "theme_selbu";
  if (centerId === "2630" || centerId === "2635") return "theme_telemark";
  if (centerId === "3060") return "theme_spareskilling";
  if (centerId === "4336") return "theme_stbank";
  if (centerId === "3090") return "theme_sogne";
  if (centerId === "1885") return "theme_tos";
  if (centerId === "3480") return "theme_voss";
  if (centerId === "4290") return "theme_orland";
  if (centerId === "1870") return "theme_odal";

  return "theme_default";
};

const UseAddThemeToHtmlElement: IUseAddThemeToHtmlElement = ({ centerId }) => {
  useEffect(() => {
    const theme = GetBankColorTheme(centerId);
    for (let i = document.documentElement.classList.length - 1; i >= 0; i--) {
      const className = document.documentElement.classList[i];
      if (className.startsWith("theme")) {
        document.documentElement.classList.remove(className);
      }
    }
    document.documentElement.classList.add(theme);
  }, [centerId]);
};

export default UseAddThemeToHtmlElement;
